import { merchandiseCategories } from "rtr-constants";

type Product = {
  merchandisingCategory?: string | null;
};

export function isBulk(product: Product): boolean {
  return product?.merchandisingCategory?.toUpperCase() === merchandiseCategories.bulk;
}

export function isClearance(product: Product): boolean {
  return product?.merchandisingCategory?.toUpperCase() === merchandiseCategories.clearance;
}

export function isRental(product: Product): boolean {
  return product?.merchandisingCategory?.toUpperCase() === merchandiseCategories.rental;
}
